import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    OnDestroy,
    ViewChildren,
} from '@angular/core';

import { BirthVocabService } from './birth-vocab.service';

import { BaseFilter } from '../common/facet';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
    focusElementByQuery
} from '../common/util/';
import { Subscription } from 'rxjs';
import { NgModel } from '@angular/forms';
import { LoggingService } from '@services/logging.service';
import { dateControlValidator } from '@common/util/date-control.validator';


@Component({
    selector: 'birth-filter',
    templateUrl: './birth-filter.component.html'
})
export class BirthFilterComponent extends BaseFilter implements OnInit, OnDestroy {
    @ViewChildren('dateControl') dateControls: NgModel[];
    @Input() filter: any = {};
    @Output() onFilter = new EventEmitter<any>();
    @Output() close = new EventEmitter<any>();

    // CVs
    birthStatuses: any[] = [];
    taxons: any[] = [];
    _subs: Subscription[] = [];

    constructor(
        private birthVocabService: BirthVocabService,
        private activeModal: NgbActiveModal,
        private loggingService: LoggingService,
    ) {
        super(activeModal);
    }

    ngOnInit() {
        this.cloneFilter();

        this.getCVs();

        focusElementByQuery('[data-auto-focus="birthID"]');
    }

    private cloneFilter() {
        const dateMatingStart = this.filter.DateMatingStart;
        const dateMatingEnd = this.filter.DateMatingEnd;
        const dateBornStart = this.filter.DateBornStart;
        const dateBornEnd = this.filter.DateBornEnd;
        const dateWeanStart = this.filter.DateWeanStart;
        const dateWeanEnd = this.filter.DateWeanEnd;

        this.filter = this.copyFilter(this.filter);

        this.filter.DateMatingStart = dateMatingStart;
        this.filter.DateMatingEnd = dateMatingEnd;
        this.filter.DateBornStart = dateBornStart;
        this.filter.DateBornEnd = dateBornEnd;
        this.filter.DateWeanStart = dateWeanStart;
        this.filter.DateWeanEnd = dateWeanEnd;
    }

    ngOnDestroy() {
        for (const s of this._subs) {
            s.unsubscribe();
        }
    }

    private getCVs() {
        this.birthVocabService.birthStatuses$
            .subscribe((data) => {
                this.birthStatuses = data;
            });

        this.birthVocabService.taxons$
            .subscribe((taxons) => {
                this.taxons = taxons;
            });
    }

    filterClicked(event: Event) {
        const errMessage = dateControlValidator(this.dateControls);
        if (errMessage) {
            this.loggingService.logError(errMessage, null, '', true);
            return;
        }
        event.preventDefault();
        this.onFilter.emit(this.filter);
        this.close.emit();
        this.activeModal.close();
    }

    closeClicked() {
        this.close.emit();
        this.activeModal.dismiss();
    }

    clearClicked() {
        this.filter = {};
        this.onFilter.emit(this.filter);
        this.close.emit();
        this.activeModal.close();
    }
}
